/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./resource-list.vue?vue&type=template&id=4beb9b5a&scoped=true&"
import script from "./resource-list.vue?vue&type=script&lang=js&"
export * from "./resource-list.vue?vue&type=script&lang=js&"
import style0 from "./resource-list.vue?vue&type=style&index=0&id=4beb9b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb9b5a",
  null
  
)

export default component.exports